import React, { useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import companyInfo from 'constants/companyInfo'
import { StickyHeaderContainer } from 'components/elements/header'
import { concat } from 'lodash'

const IntroduceCompany = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const { t: translation } = useTranslation()

  return (
    <div className="bg-background custom-container">
      <StickyHeaderContainer showArrowLeft={true} title={translation('footer.about-company')} />
      <div className="custom-content-style">
        <p>
          <strong>{companyInfo.name}</strong>
        </p>
        <p>Mã số thuế: {companyInfo.taxId}</p>
        <p>Địa chỉ: {companyInfo.address}</p>
        <p>Người ĐDPL: {companyInfo.director}</p>
        <p>Ngày hoạt động: {companyInfo.dateOfOperation}</p>
        <p>Giấy phép kinh doanh: {companyInfo.taxId}</p>
        <p>Email: {companyInfo.email}</p>
        <p>Số Hotline: {companyInfo.hotline}</p>
      </div>
    </div>
  )
}

export default IntroduceCompany
